// The only name title a user can register with. The backend stores it lowercase.
export const NAME_TITLE = 'dr.'

// Nationalities (country ids) where the family name comes first.
const FAMILY_NAME_FIRST_NATIONALITIES = [1, 1103, 1117, 1124]

// The single place where a user's name is composed for display: the title always
// goes after the name ("Kiss János dr"). The title is lowercased here as well,
// because the persisted profile may still hold the old "Dr." until it is refreshed.
// Without nationalityId the Hungarian (family name first) order is used.
export const formatUserName = (user, { nationalityId } = {}) => {
  if (!user) {
    return ''
  }
  const familyNameFirst = nationalityId === undefined || FAMILY_NAME_FIRST_NATIONALITIES.includes(nationalityId)
  const names = familyNameFirst ? [user.familyName, user.firstName] : [user.firstName, user.familyName]
  const title = user.nameTitle ? user.nameTitle.trim().toLowerCase().replace(/\.$/, '') : ''
  return [...names, title].filter(Boolean).join(' ')
}
